export const TestimonialData  = [
    {
        id: 1,
        title: "Made the immigration process incredibly smooth.",
        testimony: "GIT Global made the immigration process incredibly smooth for my family. We were unsure about the steps, but their team walked us through everything, making it easy. I couldn’t be happier with their professionalism and attention to detail.",
        authur: "John S.",
    },
    {
        id: 2,
        title: "Expertise in crypto taxes is unmatched.",
        testimony: "I had a complicated tax situation with crypto, and GIT Global handled it with ease. Their expertise in crypto taxes is unmatched, and they saved me a ton of time and stress during tax season. Highly recommend!",
        authur: "Sarah M.",
    },
    {
        id: 3,
        title: "Explained every step and kept me updated.",
        testimony: "I needed help with my citizenship application, and GIT Global was amazing. They explained every step, kept me updated, and made sure everything was submitted correctly. I felt very supported throughout the process.",
        authur: "Mohamed A.",
    },
    {
        id: 4,
        title: "Both processes were seamless.",
        testimony: "The team at GIT Global really knows their stuff when it comes to both immigration and taxes. They helped me with my green card application and tax filing, and both processes were seamless. I’m very grateful for their help!",
        authur: "Emily R.",
    },
]